


















































import app from "@/app";
import { SXQuestion, SXSurvey } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class WSurveyRunner extends BaseComponent {
	@Prop({ type: SXSurvey, required: true })
	survey!: SXSurvey;

	activeIndex = 0;
	currentAnswerValid = false;
	userPhone: string = "";
	userInfoTitle: string = "SX_LANG_SURVEY_USER_INFO_TITLE";
	answers: any = {};

	@Watch("activeIndex")
	watchActiveIndex() {
		this.updateValidity();
	}
	@Watch("surveyCompleted")
	watchSurveyCompleted(val: boolean) {
		if (val) {
			app.services.answers.addUserAnswer(
				this.userPhone,
				this.survey,
				this.answers
			);

			app.view.dialog({
				type: "done",
				text: "SX_LANG_SURVEY_COMPLETED"
			});

			app.router.goBack();
		}
	}

	get injectedAnswer() {
		let id = this.question ? this.question.id : null;
		return id && this.answers[id];
	}

	get userInfoForm() {
		return getForm();
	}

	get surveyCompleted() {
		// current answer is valid and there is no more question
		return this.currentAnswerValid && !this.question;
	}
	get questions(): SXQuestion[] {
		return app.services.surveys.surveyQuestions(this.survey);

		/*app.services.questions.select(list, function(q) {
																				// question with a valid id only
																				return q.id;
																			});*/
	}
	get question(): SXQuestion {
		return this.questions[this.activeIndex] as SXQuestion;
	}
	get canGoBack() {
		return this.activeIndex > 0;
	}
	get canGoNext() {
		return (
			this.currentAnswerValid && this.activeIndex < this.questions.length
		);
	}

	goNext() {
		if (this.canGoNext && !this.surveyCompleted) {
			this.activeIndex++;
		}
	}
	goBack() {
		if (this.canGoBack) {
			this.activeIndex--;
		}
	}
	updateValidity() {
		let q = this.question;
		if (q) {
			let a = (this.answers as any)[q.id];
			this.currentAnswerValid = this.ux_answer_valid(q, a);
		}
	}

	checkUserInfo($event: any) {
		let ctx = this,
			form = <HTMLFormElement>$event.target,
			required = ["phone"],
			ofv;

		ofv = app.getFormValidator(form, required);

		if (ofv.validate()) {
			this.userPhone = ofv.getField("phone");
		}
	}

	onQuestionAnswerChange(q: SXQuestion, answer: any) {
		(this.answers as any)[q.id] = answer;
		this.updateValidity();
	}
}

const getForm = function() {
	return {
		fields: {
			phone: {
				field: "phone",
				attrs: {
					name: "phone",
					autocomplete: "off",
					autofocus: "autofocus"
				},
				label: { i18n: "OO_LANG_PHONE" }
			},
			submit: { field: "submit", i18n: "SX_LANG_NEXT" }
		}
	};
};
